// Predefined list of tags for plays
// These tags can be used for categorizing and searching plays

export const AVAILABLE_TAGS = [
  'Offense',
  'Defense',
  'Set Piece',
  'Corner Kick',
  'Free Kick',
  'Penalty',
  'Counter Attack',
  'Possession',
  'Pressing',
  'Transition',
  'Formation',
  'Tactical',
  'Drill',
  'Warm-up',
  'Game Situation',
  'Beginner',
  'Intermediate',
  'Advanced',
  'Youth',
  'Professional',
  'Speed',
  'Passing',
  'Shooting',
  'Defending',
  'Midfield',
  'Forward',
  'Back',
  'Left',
  'Right',
  'Center',
  'Wing',
  'Center Back',
  'Center Midfield',
  'Center Midfielder',
  'Center Forward',
  '1v1',
  '2v2',
  '3v3',
  '4v4',
  '5v5',
  '6v6',
  '7v7',
  '8v8',
  '9v9',
  '10v10',
  '11v11',
  '1v2',
  '1v3',
  '2v3',
  '2v4',
  '2v5',
  '3v4',
  '3v5',
  '3v6'

]

// Tag categories for better organization (optional, for future UI improvements)
export const TAG_CATEGORIES = {
  'Play Type': ['Offense', 'Defense', 'Set Piece', 'Corner Kick', 'Free Kick', 'Penalty', 'Counter Attack', 'Possession', 'Pressing', 'Transition'],
  'Style': ['Formation', 'Tactical', 'Drill', 'Warm-up', 'Game Situation'],
  'Level': ['Beginner', 'Intermediate', 'Advanced', 'Youth', 'Professional']
}

export default AVAILABLE_TAGS

